module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"link":"Link (URL)"},"fr":{"link":"Lien (URL)"}}')
  delete Component.options._Ctor
}
